import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

export default function MesafeliSatisPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-100 via-fuchsia-50 to-sky-100">
      {/* Header */}
      <header className="bg-white/70 backdrop-blur-xl border-b border-white/20 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-3 hover:opacity-80 transition-opacity"
            >
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <h1 className="text-2xl font-bold text-slate-900">QuizMind</h1>
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl p-8 md:p-12 border border-slate-100 shadow-sm"
        >
          <h1 className="text-3xl font-bold text-slate-900 mb-2">
            Mesafeli Satış Sözleşmesi
          </h1>
          <p className="text-sm text-slate-500 mb-8">Son Güncelleme: Şubat 2026</p>

          <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">

            {/* Madde 1 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 1 – TARAFLAR</h2>
              <p><strong>Satıcı:</strong></p>
              <p>Unvan: QuizMind<br />
              E-posta: support@quizmind.net<br />
              Web Sitesi: www.quizmind.net</p>
              <p className="mt-3"><strong>Alıcı:</strong></p>
              <p>Web sitesi üzerinden kayıt olan ve/veya alışveriş yapan kullanıcı.</p>
            </section>

            {/* Madde 2 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 2 – KONU</h2>
              <p>
                İşbu Mesafeli Satış Sözleşmesi ("Sözleşme"), 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve
                Mesafeli Sözleşmeler Yönetmeliği hükümleri çerçevesinde, Satıcı ile Alıcı arasında, Alıcı'nın
                QuizMind platformu üzerinden satın aldığı dijital ürün ve hizmetlere ilişkin hak ve yükümlülükleri
                düzenlemektedir.
              </p>
            </section>

            {/* Madde 3 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 3 – ÜRÜN / HİZMET BİLGİLERİ</h2>
              <p>
                Satışa konu ürün; QuizMind platformunda sunulan kişilik testi ve değerlendirme raporlarına erişim
                hakkından oluşan dijital içeriktir. Ürünün temel özellikleri, fiyatı ve içeriği ilgili test sayfasında
                Alıcı'ya açıkça gösterilmektedir.
              </p>
            </section>

            {/* Madde 4 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 4 – FİYAT VE ÖDEME</h2>
              <p>
                Ürün fiyatı, satın alma ekranında Alıcı'nın bulunduğu ülkenin para birimiyle birlikte açıkça
                belirtilmektedir. Tüm ödemeler, güvenli üçüncü taraf ödeme altyapısı üzerinden işlenmektedir.
                Ödeme işlemi tamamlandığında satış gerçekleşmiş sayılır.
              </p>
            </section>

            {/* Madde 5 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 5 – TESLİMAT</h2>
              <p>
                Satışa konu dijital içerik, ödemenin onaylanmasının hemen ardından elektronik ortamda Alıcı'ya
                sunulmaktadır. Teslimat; test sonuç raporunun ekranda görüntülenmesi ve/veya Alıcı'nın belirttiği
                e-posta adresine gönderilmesi yoluyla gerçekleştirilir.
              </p>
            </section>

            {/* Madde 6 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 6 – CAYMA HAKKI VE İADE</h2>
              <p>
                Hizmetimizden memnun kalmadıysanız, test sonuç sayfanızın bağlantısını (linkini){' '}
                <a href="mailto:iade@quizmind.net" className="text-violet-600 hover:underline font-medium">
                  iade@quizmind.net
                </a>{' '}
                adresine ileterek ücret iadesi talebinde bulunabilirsiniz. Talepler bireysel olarak
                değerlendirilerek en kısa sürede yanıtlanacaktır.
              </p>
            </section>

            {/* Madde 7 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 7 – İADE VE İPTAL</h2>
              <p>
                <strong>Hizmetimizden memnun kalmadıysanız</strong>, test sonuç sayfanızın bağlantısını (linkini){' '}
                <a href="mailto:iade@quizmind.net" className="text-violet-600 hover:underline font-medium">
                  iade@quizmind.net
                </a>{' '}
                adresine ileterek ücret iadesi talebinde bulunabilirsiniz. Talepler bireysel olarak
                değerlendirilerek en kısa sürede yanıtlanacaktır.
              </p>
            </section>

            {/* Madde 8 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 8 – GİZLİLİK VE KİŞİSEL VERİLER</h2>
              <p>
                Alıcı'ya ait kişisel veriler (ad, e-posta, konum bilgisi vb.), yalnızca hizmetin sunulması ve
                ödemenin gerçekleştirilmesi amacıyla işlenmektedir. Veriler, Satıcı'nın Gizlilik Politikası
                kapsamında korunmakta olup üçüncü taraflarla paylaşılmamaktadır. Detaylı bilgi için:
                <button
                  onClick={() => window.open('/privacy', '_blank')}
                  className="text-violet-600 hover:underline ml-1"
                >
                  Gizlilik Politikası
                </button>
              </p>
            </section>

            {/* Madde 9 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 9 – UYUŞMAZLIK ÇÖZÜMÜ</h2>
              <p>
                İşbu Sözleşme'den doğabilecek uyuşmazlıklarda öncelikle Satıcı ile iletişime geçilmesi tavsiye
                edilir (support@quizmind.net). Tüketici, şikâyetlerini ayrıca T.C. Ticaret Bakanlığı'na bağlı
                Tüketici Hakem Heyetleri veya Tüketici Mahkemeleri aracılığıyla iletebilir.
              </p>
            </section>

            {/* Madde 10 */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-2">MADDE 10 – YÜRÜRLÜK</h2>
              <p>
                Alıcı, ödeme işlemini tamamlayarak işbu Mesafeli Satış Sözleşmesi'nin tüm hükümlerini okuduğunu,
                anladığını ve kabul ettiğini beyan eder. Sözleşme, ödemenin onaylandığı anda yürürlüğe girer.
              </p>
            </section>

          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="bg-white/50 backdrop-blur-sm border-t border-slate-100 py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-center gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500 flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
              <span className="text-sm text-slate-600">QuizMind</span>
            </div>
            <p className="text-sm text-slate-600">QuizMind © 2026</p>
          </div>
        </div>
      </footer>
    </div>
  );
}